module.exports = __webpack_public_path__ + "static/media/Image4.af83be74.JPG";